import {URL, METHOD} from "utils/constants";

const fetchRequest = (url, method, param) => {
  const headers = {"Content-Type": "application/json; charset=utf-8"};

  if (localStorage.getItem("redbrickToken")) {
    headers["Authorization"] = localStorage.getItem("redbrickToken");
  }
  if (param) {
    return fetch(url, {
      method,
      headers,
      body: JSON.stringify(param),
    });
  } else {
    return fetch(url, {
      method,
      headers,
    });
  }
};

export const generateVoiceChatToken = params => {
  return fetchRequest(`${URL.CHAT_SOCKET_SERVER}/rtcToken`, METHOD.POST, params);
};

export const generateRtmToken = () => {
  return fetchRequest(`${URL.CHAT_SOCKET_SERVER}/rtmToken`, METHOD.GET);
};

export const getWorldUsers_v2 = world => {
  return fetchRequest(`${URL.CHAT_SOCKET_SERVER}/world/${world}/users`, METHOD.GET);
};

export const postActiveUser = params => {
  return fetchRequest(`${URL.CHAT_SOCKET_SERVER}/activeUser`, METHOD.POST, params);
};
